import { render, staticRenderFns } from "./ProcessDocumentUnblockDocumentsInAppTab.vue?vue&type=template&id=49bb6de8&scoped=true"
import script from "./ProcessDocumentUnblockDocumentsInAppTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentUnblockDocumentsInAppTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb6de8",
  null
  
)

export default component.exports